export const COMMAND_DECK_STATUS_MARKER = 'KAIROS_COMMAND_DECK_STATUS_STRIP_DESKTOP';
export const COMMAND_DECK_STATUS_OVERFLOW_MARKER = 'KAIROS_COMMAND_DECK_STATUS_OVERFLOW_SAFE_SIGNAL';
export const COMMAND_DECK_CLINICAL_STATUS_MARKER = 'KAIROS_COMMAND_DECK_CLINICAL_STATUS_SIGNAL';
export const COMMAND_DECK_REPORT_CONTEXT_MARKER = 'KAIROS_COMMAND_DECK_REPORT_CONTEXT_SIGNAL';
export const COMMAND_DECK_SLICE_PROGRESS_MARKER = 'KAIROS_COMMAND_DECK_SLICE_PROGRESS_SIGNAL';
export const COMMAND_DECK_PROTOCOL_STATUS_MARKER = 'KAIROS_COMMAND_DECK_PROTOCOL_STATUS_SIGNAL';
export const COMMAND_DECK_ZOOM_FIT_MARKER = 'KAIROS_COMMAND_DECK_ZOOM_FIT_SIGNAL';
export const COMMAND_DECK_WINDOW_LEVEL_MARKER = 'KAIROS_COMMAND_DECK_WINDOW_LEVEL_SIGNAL';
export const COMMAND_DECK_WINDOW_LEVEL_PRESET_MARKER = 'KAIROS_COMMAND_DECK_WINDOW_LEVEL_PRESET_SIGNAL';
export const COMMAND_DECK_MPR_FUSION_MARKER = 'KAIROS_COMMAND_DECK_MPR_FUSION_SIGNAL';
export const COMMAND_DECK_ACTIVE_SERIES_MARKER = 'KAIROS_COMMAND_DECK_ACTIVE_SERIES_SIGNAL';
export const COMMAND_DECK_FREEZE_MARKER = 'KAIROS_COMMAND_DECK_FREEZE_SIGNAL';
export const COMMAND_DECK_PLANE_MARKER = 'KAIROS_COMMAND_DECK_PLANE_SIGNAL';
export const COMMAND_DECK_SLICE_THICKNESS_MARKER = 'KAIROS_COMMAND_DECK_SLICE_THICKNESS_SIGNAL';
export const COMMAND_DECK_SERIES_COUNT_MARKER = 'KAIROS_COMMAND_DECK_SERIES_COUNT_SIGNAL';
export const COMMAND_DECK_ANATOMY_MARKER = 'KAIROS_COMMAND_DECK_SERIES_ANATOMY_SIGNAL';
export const COMMAND_DECK_ACQUISITION_TIME_MARKER = 'KAIROS_COMMAND_DECK_ACQUISITION_TIME_SIGNAL';
export const COMMAND_DECK_STUDY_DATE_MARKER = 'KAIROS_COMMAND_DECK_STUDY_DATE_SIGNAL';
export const COMMAND_DECK_CONTRAST_PHASE_MARKER = 'KAIROS_COMMAND_DECK_CONTRAST_PHASE_SIGNAL';
export const COMMAND_DECK_SEQUENCE_MARKER = 'KAIROS_COMMAND_DECK_SEQUENCE_SIGNAL';
export const COMMAND_DECK_RECON_KERNEL_MARKER = 'KAIROS_COMMAND_DECK_RECON_KERNEL_SIGNAL';
export const COMMAND_DECK_PATIENT_POSITION_MARKER = 'KAIROS_COMMAND_DECK_PATIENT_POSITION_SIGNAL';
export const COMMAND_DECK_ACCESSION_MARKER = 'KAIROS_COMMAND_DECK_ACCESSION_SIGNAL';
export const COMMAND_DECK_PATIENT_ID_MARKER = 'KAIROS_COMMAND_DECK_PATIENT_ID_SIGNAL';
export const COMMAND_DECK_PATIENT_DEMOGRAPHICS_MARKER = 'KAIROS_COMMAND_DECK_PATIENT_DEMOGRAPHICS_SIGNAL';
export const COMMAND_DECK_STUDY_DESCRIPTION_MARKER = 'KAIROS_COMMAND_DECK_STUDY_DESCRIPTION_SIGNAL';
export const COMMAND_DECK_STUDY_TIME_MARKER = 'KAIROS_COMMAND_DECK_STUDY_TIME_SIGNAL';
export const COMMAND_DECK_MODALITY_MARKER = 'KAIROS_COMMAND_DECK_MODALITY_SIGNAL';
export const COMMAND_DECK_PROTOCOL_NAME_MARKER = 'KAIROS_COMMAND_DECK_PROTOCOL_NAME_SIGNAL';
export const COMMAND_DECK_SERIES_NUMBER_MARKER = 'KAIROS_COMMAND_DECK_SERIES_NUMBER_SIGNAL';
export const COMMAND_DECK_ACQUISITION_NUMBER_MARKER = 'KAIROS_COMMAND_DECK_ACQUISITION_NUMBER_SIGNAL';
export const COMMAND_DECK_PIXEL_SPACING_MARKER = 'KAIROS_COMMAND_DECK_PIXEL_SPACING_SIGNAL';
export const COMMAND_DECK_MANUFACTURER_MARKER = 'KAIROS_COMMAND_DECK_MANUFACTURER_SIGNAL';
export const COMMAND_DECK_MODEL_MARKER = 'KAIROS_COMMAND_DECK_SCANNER_MODEL_SIGNAL';
export const COMMAND_DECK_INSTITUTION_MARKER = 'KAIROS_COMMAND_DECK_INSTITUTION_SIGNAL';
export const COMMAND_DECK_STATION_MARKER = 'KAIROS_COMMAND_DECK_STATION_SIGNAL';

const cleanCommandDeckToken = (value, maxLength = 18) => String(value ?? '')
  .replace(/[^a-z0-9\s/_-]/gi, ' ')
  .replace(/\s+/g, ' ')
  .trim()
  .toUpperCase()
  .slice(0, maxLength)
  .trim();


const normalizeDicomTimeParts = (raw) => {
  const text = String(raw ?? '').trim();
  if (!text) return null;
  const timePart = text.includes('T') ? text.split('T').pop() : text;
  const digits = timePart.replace(/[^0-9]/g, '');
  if (digits.length < 2) return null;
  const looksLikeDicomDateTime = !text.includes('T') && digits.length >= 12;
  const timeDigits = looksLikeDicomDateTime ? digits.slice(8) : digits;
  const hour = Number(timeDigits.slice(0, 2));
  const minute = timeDigits.length >= 4 ? Number(timeDigits.slice(2, 4)) : 0;
  // Deliberately reject DICOM 24:00:00 midnight shorthand for this compact clinical label.
  if (!Number.isInteger(hour) || !Number.isInteger(minute) || hour < 0 || hour > 23 || minute < 0 || minute > 59) return null;
  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
};

const normalizeDicomDateLabel = (raw) => {
  const text = String(raw ?? '').trim();
  if (!text) return null;
  const isoMatch = text.match(/^(\d{4})-?(\d{2})-?(\d{2})/);
  if (!isoMatch) return null;
  const [, year, month, day] = isoMatch;
  const numericYear = Number(year);
  const numericMonth = Number(month);
  const numericDay = Number(day);
  if (!Number.isInteger(numericYear) || numericYear < 1900 || numericYear > 2200) return null;
  if (!Number.isInteger(numericMonth) || numericMonth < 1 || numericMonth > 12) return null;
  if (!Number.isInteger(numericDay) || numericDay < 1 || numericDay > 31) return null;
  const candidate = new Date(Date.UTC(numericYear, numericMonth - 1, numericDay));
  if (candidate.getUTCFullYear() !== numericYear || candidate.getUTCMonth() !== numericMonth - 1 || candidate.getUTCDate() !== numericDay) return null;
  return `${year}-${month}-${day}`;
};

export const describeStudyDateForCommandDeck = (studyInfo, series) => {
  const label = normalizeDicomDateLabel(
    studyInfo?.studyDate
      ?? studyInfo?.StudyDate
      ?? series?.studyDate
      ?? series?.StudyDate
  );
  return label ? `DATE ${label}` : 'DATE --';
};

export const describeStudyTimeForCommandDeck = (studyInfo, series) => {
  const label = normalizeDicomTimeParts(
    studyInfo?.studyTime
      ?? studyInfo?.study_time
      ?? studyInfo?.StudyTime
      ?? series?.studyTime
      ?? series?.StudyTime
  );
  return label ? `TIME ${label}` : 'TIME --';
};

export const describeAccessionForCommandDeck = (studyInfo) => {
  const raw = studyInfo?.accessionNumber
    ?? studyInfo?.accession_number
    ?? studyInfo?.AccessionNumber;
  const token = cleanCommandDeckToken(raw, 18);
  return token ? `ACC ${token}` : 'ACC --';
};

export const describePatientIdForCommandDeck = (studyInfo) => {
  const raw = studyInfo?.patientId
    ?? studyInfo?.patient_id
    ?? studyInfo?.PatientID
    ?? studyInfo?.PatientId;
  const token = cleanCommandDeckToken(raw, 16);
  return token ? `PID ${token}` : 'PID --';
};

export const describeStudyDescriptionForCommandDeck = (studyInfo) => {
  const raw = studyInfo?.studyDescription
    ?? studyInfo?.study_description
    ?? studyInfo?.StudyDescription;
  const token = cleanCommandDeckToken(raw, 24);
  return token ? `STUDY ${token}` : 'STUDY --';
};

export const describePatientDemographicsForCommandDeck = (studyInfo) => {
  const rawSex = cleanCommandDeckToken(
    studyInfo?.patientSex
      ?? studyInfo?.patient_sex
      ?? studyInfo?.PatientSex
      ?? studyInfo?.sex,
    8
  );
  const sex = ['M', 'F', 'O', 'U'].includes(rawSex) ? rawSex : '';
  const rawAge = String(
    studyInfo?.patientAge
      ?? studyInfo?.patient_age
      ?? studyInfo?.PatientAge
      ?? studyInfo?.age
      ?? ''
  ).trim().toUpperCase();
  let age = '';
  const dicomAge = rawAge.match(/^(\d{1,3})([DWMY])$/);
  const plainAge = rawAge.match(/^\d{1,3}$/);
  if (dicomAge) {
    age = `${dicomAge[1].padStart(3, '0')}${dicomAge[2]}`;
  } else if (plainAge) {
    age = `${rawAge.padStart(3, '0')}Y`;
  }
  const parts = [sex, age].filter(Boolean);
  return parts.length ? `DEM ${parts.join(' ')}` : 'DEM --';
};

export const describeModalityForCommandDeck = (studyInfo, series) => {
  const raw = series?.modality
    ?? series?.Modality
    ?? studyInfo?.modality
    ?? studyInfo?.Modality;
  const token = cleanCommandDeckToken(raw, 6);
  if (!token) return 'MOD --';
  // Keep this passive context chip to the DICOM modality token only; do not infer modality
  // from descriptions or protocol names where an MR/CT/PET word can describe a comparison.
  return `MOD ${token}`;
};

export const describeProtocolNameForCommandDeck = (series) => {
  const raw = series?.protocolName
    ?? series?.protocol_name
    ?? series?.ProtocolName;
  const token = cleanCommandDeckToken(raw, 22);
  return token ? `PROT ${token}` : 'PROT --';
};

export const describeSeriesNumberForCommandDeck = (series) => {
  const raw = series?.seriesNumber
    ?? series?.series_number
    ?? series?.SeriesNumber;
  const text = String(raw ?? '').trim();
  if (!text || text === '?' || /[<>]/.test(text)) return 'S# --';
  const token = text.replace(/[^a-z0-9._-]/gi, '').toUpperCase().slice(0, 8);
  return token ? `S# ${token}` : 'S# --';
};

export const describeAcquisitionNumberForCommandDeck = (series) => {
  const raw = series?.acquisitionNumber
    ?? series?.acquisition_number
    ?? series?.AcquisitionNumber;
  const text = String(raw ?? '').trim();
  if (!text || text === '?' || /[<>]/.test(text)) return 'ACQ# --';
  const token = text.replace(/[^a-z0-9._-]/gi, '').toUpperCase().slice(0, 8);
  return token ? `ACQ# ${token}` : 'ACQ# --';
};

const normalizePixelSpacingPair = (raw) => {
  const source = raw?.Value ?? raw;
  const values = Array.isArray(source)
    ? source
    : String(source ?? '')
      .split(/[\\\s,]+/)
      .filter(Boolean);
  if (values.length < 2) return null;
  const pair = values.slice(0, 2).map((value) => Number(value));
  if (pair.some((value) => !Number.isFinite(value) || value <= 0 || value > 20)) return null;
  return pair;
};

const formatPixelSpacingValue = (value) => {
  if (value >= 10) return value.toFixed(1).replace(/\.0$/, '');
  if (value >= 1) return value.toFixed(2).replace(/0$/, '').replace(/\.0$/, '');
  return value.toFixed(3).replace(/0+$/, '').replace(/\.$/, '');
};

export const describePixelSpacingForCommandDeck = (series) => {
  const pair = normalizePixelSpacingPair(
    series?.pixelSpacing
      ?? series?.pixel_spacing
      ?? series?.PixelSpacing
      ?? series?.imagerPixelSpacing
      ?? series?.ImagerPixelSpacing
  );
  return pair ? `PX ${formatPixelSpacingValue(pair[0])}×${formatPixelSpacingValue(pair[1])}mm` : 'PX --';
};

export const describeManufacturerForCommandDeck = (series) => {
  const raw = series?.manufacturer
    ?? series?.Manufacturer
    ?? series?.manufacturerName
    ?? series?.manufacturer_name;
  const token = cleanCommandDeckToken(raw, 16);
  return token ? `MFR ${token}` : 'MFR --';
};


export const describeScannerModelForCommandDeck = (series) => {
  const raw = series?.manufacturerModelName
    ?? series?.manufacturer_model_name
    ?? series?.ManufacturerModelName
    ?? series?.modelName
    ?? series?.scannerModel;
  const token = cleanCommandDeckToken(raw, 18);
  return token ? `MODEL ${token}` : 'MODEL --';
};

export const describeStationForCommandDeck = (series) => {
  const raw = series?.stationName
    ?? series?.station_name
    ?? series?.StationName;
  const token = cleanCommandDeckToken(raw, 16);
  return token ? `STN ${token}` : 'STN --';
};

export const describeInstitutionForCommandDeck = (series, studyInfo) => {
  const raw = series?.institutionName
    ?? series?.institution_name
    ?? series?.InstitutionName
    ?? studyInfo?.institutionName
    ?? studyInfo?.institution_name
    ?? studyInfo?.InstitutionName;
  const token = cleanCommandDeckToken(raw, 18);
  return token ? `SITE ${token}` : 'SITE --';
};

export const describeAcquisitionTimeForCommandDeck = (series) => {
  if (!series) return 'ACQ --';
  const label = normalizeDicomTimeParts(
    series.acquisitionDateTime
      ?? series.AcquisitionDateTime
      ?? series.acquisitionTime
      ?? series.AcquisitionTime
      ?? series.seriesTime
      ?? series.SeriesTime
  );
  return label ? `ACQ ${label}` : 'ACQ --';
};


export const describeContrastPhaseForCommandDeck = (series) => {
  if (!series) return 'PHASE --';
  const text = [
    series.contrastPhase,
    series.contrast_phase,
    series.phase,
    series.seriesDescription,
    series.description,
    series.SeriesDescription,
    series.protocolName,
    series.ProtocolName,
  ].filter(Boolean).join(' ')
    .replace(/[_-]+/g, ' ')
    .replace(/T2\s*\*/gi, 'T2STAR')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();
  if (!text) return 'PHASE --';
  if (/\b(NON\s*CONTRAST|NON\s*CON|NONCON|NO\s*CONTRAST|WITHOUT\s*CONTRAST|PRE\s*CON|PRECON|NAC|W\/O)\b/.test(text)) return 'PHASE NONCON';
  if (/\b(ARTERIAL|ART|CTA|ANGIO)\b/.test(text)) return 'PHASE ART';
  if (/\b(PORTAL\s*VENOUS|PORTO\s*VENOUS|PV|VENOUS|VEN)\b/.test(text)) return 'PHASE VEN';
  if (/\b(DELAYED|DELAY|EQUILIBRIUM|EQUIL)\b/.test(text)) return 'PHASE DELAY';
  if (/\b(POST\s*CON|POSTCON|POST|WITH\s*CONTRAST|CONTRAST|C\+)\b/.test(text)) return 'PHASE POST';
  return 'PHASE --';
};


export const describeReconKernelForCommandDeck = (series) => {
  if (!series) return 'KERNEL --';
  const text = [
    series.convolutionKernel,
    series.convolution_kernel,
    series.ConvolutionKernel,
    series.reconstructionKernel,
    series.reconstruction_kernel,
    series.ReconstructionKernel,
  ].filter(Boolean).join(' ')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();
  if (!text) return 'KERNEL --';
  if (/\b(BONE|SHARP|DETAIL|HIGH\s*RES|HR|EDGE|FC30|FC31|FC41|FC51|B70|B80)\b/.test(text)) return 'KERNEL BONE';
  if (/\b(LUNG|CHEST|PULMO|B60|FC50|HM3|HM4)\b/.test(text)) return 'KERNEL LUNG';
  if (/\b(SOFT|STANDARD|STD|SMOOTH|BODY|ABDOMEN|MEDIUM|B30|B31|FC08|FC13)\b/.test(text)) return 'KERNEL SOFT';
  const compact = cleanCommandDeckToken(text, 14);
  return compact ? 'KERNEL ' + compact : 'KERNEL --';
};


export const describePatientPositionForCommandDeck = (series) => {
  const raw = series?.patientPosition ?? series?.patient_position ?? series?.PatientPosition;
  const text = String(raw ?? '').trim();
  if (!text || /[<>]/.test(text)) return 'POS --';
  const token = text
    .replace(/[^a-z0-9]/gi, '')
    .toUpperCase()
    .slice(0, 4);
  if (!token) return 'POS --';
  const knownPositions = new Set(['HFS', 'HFP', 'FFS', 'FFP', 'HFDR', 'HFDL', 'FFDR', 'FFDL']);
  if (knownPositions.has(token)) return `POS ${token}`;
  return `POS ${token.slice(0, 3) || '--'}`;
};

export const describeSequenceForCommandDeck = (series) => {
  if (!series) return 'SEQ --';
  const text = [
    series.sequenceName,
    series.SequenceName,
    series.scanningSequence,
    series.ScanningSequence,
    series.sequenceVariant,
    series.SequenceVariant,
    series.seriesDescription,
    series.description,
    series.SeriesDescription,
    series.protocolName,
    series.ProtocolName,
  ].filter(Boolean).join(' ')
    .replace(/[_-]+/g, ' ')
    .replace(/T2\s*\*/gi, 'T2STAR')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase()
    // Compact scanner/protocol names like T2FS, PDFS, T1+C, and T1POST are common in MR.
    // Expand only status-label tokens so the passive command deck can reflect fat-sat/post-contrast
    // context without mutating underlying clinical metadata or viewport behavior.
    .replace(/\b(T1|T2|PD)(FS|FATSAT|SPAIR|SPIR)\b/g, '$1 $2')
    .replace(/\b(T1|T2)(FSE|TSE)\b/g, '$1 $2')
    .replace(/\b(T1)(POST|POSTCON|POSTCONTRAST)\b/g, '$1 $2')
    .replace(/\b(T1)\s*\+\s*C\b/g, '$1 CPLUS');
  if (!text) return 'SEQ --';
  if (/\b(ADC|APPARENT DIFFUSION)\b/.test(text)) return 'SEQ ADC';
  if (/\b(DWI|DIFFUSION|B[ -]?VALUE|TRACE)\b/.test(text)) return 'SEQ DWI';
  if (/\b(STIR|IR FSE|INVERSION RECOVERY|IR)\b/.test(text)) return 'SEQ STIR';
  if (/\b(FLAIR|T2 FLAIR)\b/.test(text)) return 'SEQ FLAIR';
  if (/\b(PD|PROTON DENSITY)\b/.test(text)) return /\b(FS|FAT\s*SAT|FATSAT|SPAIR|SPIR|FAT\s*SUPP)\b/.test(text) ? 'SEQ PD FS' : 'SEQ PD';
  if (/\b(T2\*|T2STAR|GRE|SWI)\b/.test(text)) return 'SEQ T2*';
  if (/\b(T2)\b/.test(text)) return /\b(FS|FAT\s*SAT|FATSAT|SPAIR|SPIR|FAT\s*SUPP)\b/.test(text) ? 'SEQ T2 FS' : 'SEQ T2';
  if (/\b(T1)\b/.test(text)) {
    const isExplicitPreContrast = /\b(PRE|PRECONTRAST|PRE\s*CONTRAST|NON\s*CONTRAST|NONCON)\b/.test(text);
    const isPostContrast = !isExplicitPreContrast && /\b(POST|CPLUS|C\+|GAD|CONTRAST)\b/.test(text);
    return isPostContrast ? 'SEQ T1 POST' : 'SEQ T1';
  }
  if (/\b(LOCALIZER|SCOUT|3 PLANE|THREE PLANE)\b/.test(text)) return 'SEQ LOCALIZER';
  return 'SEQ --';
};

// Series-level coded anatomy metadata, not a claim about anatomy currently visible at the cursor/slice.
export const describeAnatomyForCommandDeck = (series) => {
  if (!series) return 'SERIES ANAT --';
  const bodyPart = cleanCommandDeckToken(
    series.bodyPartExamined ?? series.body_part_examined ?? series.BodyPartExamined,
    20
  );
  const laterality = cleanCommandDeckToken(
    series.laterality ?? series.imageLaterality ?? series.Laterality ?? series.ImageLaterality,
    10
  );
  const view = cleanCommandDeckToken(
    series.viewPosition ?? series.view_position ?? series.ViewPosition,
    12
  );
  const parts = [bodyPart, laterality, view].filter(Boolean);
  return parts.length ? `SERIES ANAT ${parts.join(' · ')}` : 'SERIES ANAT --';
};

const extractSeriesPlaneText = (series) => [
  series?.plane,
  series?.orientation,
  series?.viewPosition,
  series?.ViewPosition,
  series?.imageOrientation,
  series?.seriesDescription,
  series?.description,
  series?.SeriesDescription,
  series?.protocolName,
  series?.ProtocolName,
].filter(Boolean).join(' ');

const normalizeImageOrientationPatient = (raw) => {
  if (Array.isArray(raw)) return raw.map(Number).filter(Number.isFinite);
  if (typeof raw === 'string') {
    return raw
      .split(/[\\\s,]+/)
      .map(Number)
      .filter(Number.isFinite);
  }
  return [];
};

const describePlaneFromImageOrientationPatient = (raw) => {
  const values = normalizeImageOrientationPatient(raw);
  if (values.length < 6) return null;
  const [rx, ry, rz, cx, cy, cz] = values;
  const normal = [
    (ry * cz) - (rz * cy),
    (rz * cx) - (rx * cz),
    (rx * cy) - (ry * cx),
  ];
  const magnitude = Math.hypot(...normal);
  if (!Number.isFinite(magnitude) || magnitude < 0.0001) return null;
  const normalized = normal.map(value => Math.abs(value / magnitude));
  const dominant = normalized.indexOf(Math.max(...normalized));
  // Treat materially off-axis acquisitions as oblique rather than overstating an anatomic plane.
  if (normalized[dominant] < 0.8) return 'PLANE OBLIQUE';
  if (dominant === 0) return 'PLANE SAGITTAL';
  if (dominant === 1) return 'PLANE CORONAL';
  return 'PLANE AXIAL';
};

export const describeViewportPlaneForCommandDeck = ({ series, mprMode } = {}) => {
  if (mprMode) return 'PLANE MPR TRI';
  const orientationPlane = describePlaneFromImageOrientationPatient(
    series?.imageOrientationPatient
      ?? series?.ImageOrientationPatient
      ?? series?.imageOrientation
  );
  if (orientationPlane) return orientationPlane;
  const text = String(extractSeriesPlaneText(series) || '')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();
  if (!text) return 'PLANE --';
  if (/\b(AX|AXI|AXIAL|TRANSVERSE)\b/.test(text)) return 'PLANE AXIAL';
  if (/\b(COR|CORONAL|FRONTAL)\b/.test(text)) return 'PLANE CORONAL';
  if (/\b(SAG|SAGITTAL)\b/.test(text)) return 'PLANE SAGITTAL';
  if (/\b(OBL|OBLIQUE)\b/.test(text)) return 'PLANE OBLIQUE';
  if (/\b(LOCALIZER|SCOUT|3 PLANE|THREE PLANE)\b/.test(text)) return 'PLANE LOCALIZER';
  return 'PLANE --';
};

export const describeViewportFreezeForCommandDeck = (frozen) => (frozen ? 'LOCKED' : 'LIVE');


export const describeSliceThicknessForCommandDeck = (series) => {
  const raw = series?.sliceThickness ?? series?.SliceThickness ?? series?.slice_thickness;
  const value = Number(raw);
  if (!Number.isFinite(value) || value <= 0) return 'THICK --';
  const rounded = Math.min(999, Math.max(0.1, Math.round(value * 10) / 10));
  const label = Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
  return `THICK ${label}mm`;
};

export const describeSeriesCountForCommandDeck = (series) => {
  const raw = series?.numInstances
    ?? series?.num_instances
    ?? series?.instanceCount
    ?? series?.instance_count
    ?? series?.NumberOfSeriesRelatedInstances;
  const value = Number(raw);
  if (!Number.isFinite(value) || value <= 0) return 'IMAGES --';
  const count = Math.min(9999, Math.max(1, Math.floor(value)));
  return `IMAGES ${count}`;
};

export const describeActiveSeriesForCommandDeck = (series) => {
  if (!series) return 'SERIES --';
  const modality = String(series.modality || '').replace(/[^a-z0-9/_-]/gi, ' ').replace(/\s+/g, ' ').trim().toUpperCase();
  const number = series.seriesNumber ?? series.SeriesNumber;
  const description = String(series.seriesDescription || series.description || series.SeriesDescription || '')
    .replace(/[^a-z0-9\s/_-]/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();
  const parts = [];
  if (modality) parts.push(modality);
  if (number !== undefined && number !== null && String(number).trim() !== '') parts.push(`#${String(number).replace(/[^0-9A-Z_-]/gi, '').slice(0, 8) || '?'}`);
  if (description) parts.push(description);
  const label = parts.join(' · ') || 'ACTIVE SERIES';
  return `SERIES ${label.slice(0, 56)}`;
};

const compactSeriesLabel = (series, fallback = 'SERIES') => {
  if (!series) return fallback;
  const parts = [
    series.modality,
    series.seriesDescription || series.description || series.SeriesDescription || series.seriesNumber,
  ].filter(Boolean);
  const cleaned = (parts.join(' ') || fallback)
    .replace(/[^a-z0-9\s/_-]/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();
  return (cleaned || fallback).slice(0, 34);
};

export const describeMprFusionForCommandDeck = ({ mprMode, baseSeries, petSeries, fusionOpacity, fusionColormap, fusionPetSlabMm } = {}) => {
  if (!mprMode) return 'MPR OFF';
  const baseLabel = compactSeriesLabel(baseSeries, 'BASE SERIES');
  if (!petSeries) return `MPR ${baseLabel}`;
  const opacity = Number(fusionOpacity);
  const boundedOpacity = Number.isFinite(opacity)
    ? Math.min(100, Math.max(0, Math.round(opacity * 100)))
    : 45;
  const colormap = String(fusionColormap || 'hot')
    .replace(/[^a-z0-9_-]/gi, '')
    .toUpperCase() || 'HOT';
  const slab = Number(fusionPetSlabMm);
  const slabLabel = Number.isFinite(slab) && slab > 0 ? ` · AVG ${slab}MM` : '';
  return `MPR ${baseLabel} · PET ${boundedOpacity}% ${colormap}${slabLabel}`;
};

const WINDOW_LEVEL_PRESET_LABELS = [
  { label: 'SOFT', ww: 400, wc: 40 },
  { label: 'LUNG', ww: 1500, wc: -600 },
  { label: 'CTA', ww: 600, wc: 200 },
  { label: 'BONE', ww: 2000, wc: 400 },
  { label: 'BRAIN', ww: 80, wc: 40 },
  { label: 'STROKE', ww: 40, wc: 40 },
  { label: 'ABD', ww: 350, wc: 50 },
];

const describeWindowLevelPreset = (ww, wc) => {
  const roundedWw = Math.round(ww);
  const roundedWc = Math.round(wc);
  const preset = WINDOW_LEVEL_PRESET_LABELS.find(item => Math.abs(roundedWw - item.ww) <= 2 && Math.abs(roundedWc - item.wc) <= 2);
  return preset?.label || null;
};

export const describeViewportWindowLevel = (wl) => {
  if (!wl) return 'W/L AUTO';
  const ww = Number(wl.ww);
  const wc = Number(wl.wc);
  if (!Number.isFinite(ww) || !Number.isFinite(wc) || ww <= 0) return 'W/L AUTO';
  const boundedWw = Math.min(9999, Math.max(1, Math.round(ww)));
  const boundedWc = Math.min(9999, Math.max(-9999, Math.round(wc)));
  const presetLabel = describeWindowLevelPreset(ww, wc);
  return presetLabel ? `W/L ${presetLabel} ${boundedWw}/${boundedWc}` : `W/L ${boundedWw}/${boundedWc}`;
};

export const describeViewportZoomFit = (zoom) => {
  const value = Number(zoom);
  if (!Number.isFinite(value) || value <= 0) return 'ZOOM --';
  const percent = Math.min(999, Math.max(10, Math.round(value * 100)));
  return percent === 100 ? 'ZOOM FIT' : `ZOOM ${percent}%`;
};

export const describeHangingProtocolForCommandDeck = ({ protocol, manualLayout } = {}) => {
  if (!protocol) return 'HP AUTO';
  const rawName = protocol.name || protocol.label || protocol.id || 'protocol';
  const cleanName = String(rawName).replace(/[^a-z0-9\s/_-]/gi, ' ').replace(/\s+/g, ' ').trim().toUpperCase();
  const safeName = cleanName || 'PROTOCOL';
  return `${manualLayout ? 'HP CUSTOM' : 'HP AUTO'} · ${safeName}`;
};

export const describeViewportSliceProgress = (progress) => {
  if (!progress) return 'SLICE --';
  const slice = Number(progress.slice);
  const total = Number(progress.total);
  if (!Number.isFinite(slice) || !Number.isFinite(total) || total <= 0) return 'SLICE --';
  const boundedTotal = Math.max(1, Math.floor(total));
  const boundedSlice = Math.min(Math.max(0, Math.floor(slice)), boundedTotal - 1);
  return `SLICE ${boundedSlice + 1}/${boundedTotal}`;
};

export const describeReportContextForCommandDeck = (ctx) => {
  if (!ctx || !ctx.series) return 'REPORT READY';
  const seriesLabel = [
    ctx.series.modality,
    ctx.series.seriesDescription || ctx.series.description || ctx.series.SeriesDescription,
  ].filter(Boolean).join(' ').trim() || 'ACTIVE SERIES';
  const subjectLabel = ctx.kind === 'roi' ? 'ROI' : (ctx.kind === 'measurement' ? 'MEASURE' : 'REPORT');
  const slice = Number(ctx.slice);
  const maxSlice = Number(ctx.maxSlice);
  // Viewport/report contexts carry zero-based slice indexes from Viewport.sliceRef.
  // Display them one-based for radiologist-facing read status.
  const boundedMaxSlice = Number.isFinite(maxSlice) ? Math.max(0, maxSlice) : null;
  const boundedSlice = Number.isFinite(slice)
    ? Math.min(Math.max(0, slice), boundedMaxSlice ?? Math.max(0, slice))
    : null;
  const sliceLabel = boundedSlice != null
    ? `S${boundedSlice + 1}${boundedMaxSlice != null ? `/${boundedMaxSlice + 1}` : ''}`
    : 'S?';
  return `${subjectLabel} ${sliceLabel} · ${seriesLabel}`;
};
